var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { ImportExcelConfigService } from '~/services/dataimp-service/import-excel-config.service';
var RelationName = /** @class */ (function (_super) {
    __extends(RelationName, _super);
    function RelationName() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.caseInfoList = [];
        _this.contractList = [];
        _this.personalContactList = [];
        _this.personalJobList = [];
        _this.personalList = [];
        _this.productList = [];
        _this.personalBankList = [];
        _this.personalHouseList = [];
        _this.productSeriesList = [];
        _this.personalIncomeList = [];
        _this.content = '';
        _this.carInfoList = [];
        _this.selectRelate = {};
        return _this;
    }
    RelationName.prototype.close = function () { };
    RelationName.prototype.save = function (relate, row, index) { };
    RelationName.prototype.rowDataChange = function (value) {
        this.selectRelate = value.row.relationName;
    };
    RelationName.prototype.disStr = function (v) {
        return this.disabledStr.find(function (val) { return val === v.cellName; });
    };
    RelationName.prototype.mounted = function () {
        var _this = this;
        this.importExcelConfigService.getExcelList().subscribe(function (data) {
            _this.caseInfoList = data.caseInfoList;
            _this.contractList = data.contractList;
            _this.personalContactList = data.personalContactList;
            _this.personalJobList = data.personalJobList;
            _this.personalList = data.personalList;
            _this.productSeriesList = data.productSeriesList;
            _this.productList = data.productList;
            _this.personalBankList = data.personalBankList;
            _this.personalHouseList = data.personalHouseList;
            _this.carInfoList = data.carInfoList;
            _this.personalIncomeList = data.personalIncomeList;
        });
    };
    RelationName.prototype.cancel = function () {
        this.selectRelate = '';
        this.close();
    };
    RelationName.prototype.saveClick = function () {
        this.save(this.selectRelate, this.rowData.row, this.rowData.$index);
        this.selectRelate = '';
        this.close();
    };
    __decorate([
        Prop()
    ], RelationName.prototype, "rowData", void 0);
    __decorate([
        Prop()
    ], RelationName.prototype, "disabledStr", void 0);
    __decorate([
        Dependencies(ImportExcelConfigService)
    ], RelationName.prototype, "importExcelConfigService", void 0);
    __decorate([
        Emit('close')
    ], RelationName.prototype, "close", null);
    __decorate([
        Emit('save')
    ], RelationName.prototype, "save", null);
    __decorate([
        Watch('rowData', { immediate: true })
    ], RelationName.prototype, "rowDataChange", null);
    RelationName = __decorate([
        Component({})
    ], RelationName);
    return RelationName;
}(Vue));
export default RelationName;
